/** 充值赠送档：与活动中心阶梯一致——按最低触发金额从高到低取最高命中档。 */

export const DEPOSIT_BONUS_TIERS = Object.freeze([
  /** featured：运营指定「最高赠送比例」角标档 */
  Object.freeze({ usd: 5, bonusUsd: 5, percent: 100, tone: 'gold', featured: true }),
  Object.freeze({ usd: 30, bonusUsd: 7, percent: 23, tone: 'red' }),
  Object.freeze({ usd: 50, bonusUsd: 10, percent: 20, tone: 'red' }),
  Object.freeze({ usd: 100, bonusUsd: 20, percent: 20, tone: 'red' }),
]);

/** 顶栏上下滚动主推：充5送5（金）↔ 充30送7（红） */
export const DEPOSIT_BONUS_PROMO_SLIDES = Object.freeze([
  Object.freeze({ usd: 5, bonusUsd: 5, tone: 'gold' }),
  Object.freeze({ usd: 30, bonusUsd: 7, tone: 'red' }),
]);

const TIER_MATCH_EPS = 0.009;

/** 「最高赠送比例」角标档：优先 featured，否则取 percent 最大 */
export function resolveBestDepositBonusTier() {
  const featured = DEPOSIT_BONUS_TIERS.find((tier) => tier.featured);
  if (featured) return featured;
  let best = DEPOSIT_BONUS_TIERS[0];
  for (const tier of DEPOSIT_BONUS_TIERS) {
    if (tier.percent > best.percent) best = tier;
  }
  return best;
}

/**
 * 入账 USD 命中的赠送档（高→低，取最高门槛；对齐活动中心阶梯）。
 * @param {number|string} usd
 * @returns {{ usd: number, bonusUsd: number, percent: number, tone?: string } | null}
 */
export function resolveDepositBonus(usd) {
  const n = Number(usd);
  if (!Number.isFinite(n) || n <= 0) return null;
  const sorted = [...DEPOSIT_BONUS_TIERS].sort((a, b) => b.usd - a.usd);
  return sorted.find((tier) => n + TIER_MATCH_EPS >= tier.usd) ?? null;
}

/**
 * 快捷金额按钮高亮：仅精确档（默认 $5 时高亮「充5送5」；$20 等非档位不高亮）。
 * @param {number|string} usd
 */
export function matchDepositBonusTiers(usd) {
  const n = Number(usd);
  if (!Number.isFinite(n) || n <= 0) return null;
  return DEPOSIT_BONUS_TIERS.find((tier) => Math.abs(n - tier.usd) < 0.51) ?? null;
}
